// extracted by mini-css-extract-plugin
module.exports = {"wave_box":"ParkRoad_wave_box__rtsnN","wave_box_title":"ParkRoad_wave_box_title__3TRI6","wave_item":"ParkRoad_wave_item__1XP7I","wave_item_label":"ParkRoad_wave_item_label__1P02d"};